export enum ServiceNowEntity {
    ACCOUNT = 'customer_account',
    CONTACT = 'customer_contact',
    CONSUMER = 'csm_consumer',
    CASE = 'sn_customerservice_case',
    CASE_TASK = 'sn_customerservice_task',
    INTERACTION = 'interaction',
    INCIDENT = 'incident',
    RINGCX_FOR_SERVICENOW_CONFIG = 'u_ringcx_for_servicenow_config',
    USER = 'sys_user',
}
